/**
 * mwApp.vods module <br>
 * Work with VODs: show/add/edit/remove
 *
 * @namespace mwApp/vods
 */

import AddVodCtrl from './addVod.controller'
import VodsCtrl from './vods.controller'
import vodsConfig from './vods.config'

export default
angular.module('mwApp.vods', [])
  .config(vodsConfig)
  .controller('VodsCtrl', VodsCtrl)
  .controller('AddVodCtrl', AddVodCtrl)
